<!-- TEMPLATE -->
<template>
  <div class="dean-dialog-button-group">
    <slot></slot>
  </div>
</template>

<!-- SCRIPT -->
<script lang="ts">
// VUE
import Vue from 'vue';
import { Component } from 'vue-property-decorator';

// COMPONENTS
@Component
export default class deanDialogButtonGroup extends Vue {}
</script>

<!-- STYLE -->
<style lang="scss" scoped>
// IMPORT
@import '../scss/vars';

// DEAN DIALOG BUTTON GROUP
.dean-dialog-button-group {
  display: block;
  min-width: 100%;
  margin: 0;
  overflow: hidden;
  @include border-radius(0px 0px 10px 10px);

  span {
    @include display-flex;
    -webkit-flex-wrap: wrap;
    flex-wrap: wrap;
    -ms-flex-direction: row;
    -webkit-box-orient: horizontal;
    -moz-box-orient: horizontal;
    -ms-box-orient: horizontal;
    box-orient: horizontal;
    margin: 0;
    width: 100%;
    cursor: pointer;
    text-decoration: none;
    text-transform: lowercase;
    border: none;
    overflow: hidden;
    border-top: 1px solid var(--color-light-shade-2, $color-light-shade-2);
  }
}
</style>
